export const RD_DRAWER_TAB = {
  INDIVIDUAL_GRAPHS: 'individualGraphs',
  IRRIGATION: 'irrigation',
  JOURNAL: 'journal',
}
